<template>
	<div class="vsebina ">

  <div class="glava_vsebine adapt v-adapt">

	<div class="cols">
	<div class="col left grid-col-6">
	  <h1>Nadaljni ukrepi</h1>
	</div>
	
	
	
	<div class="col right">
	</div>
	
	</div>
  </div>
  
  <div class="telo_vsebine adapt v-adapt">
<div v-if="!pridelovalecid">
  NI PODATKOV
</div>
<div v-else>
<div>
	  <div :style="{ display: 'inline-block' }">
		  Sezona
		  <br />
		  <dropdownlist
			  :data-items="sezonePisanje"
			  :text-field="'sezona'"
			  @change="sezonaChange"
			  :value="dataSezona"
		  />
      <pridelovalec :pridelovalec="pridelovalec" :sezona="dataSezona.sezona" shema="IP" :kontrolaid="kontrolaid"
                    :podshema="kontrola.podrocjecertificiranja"></pridelovalec>
		  
		</div>
	  </div>
<div class="uporabnik-spacer" style="margin-top:2rem"></div>
<div class="">
<form @submit.prevent="handleSubmit" class="k-form">

	<div class="form-group">
		<div class="km-widget km-buttongroup k-widget k-button-group">
			<button class="k-button k-primary" :disabled="editDisabled" @click="shraniKontrole" >Shrani</button>
			<button class="k-button k-primary" @click="nazaj" >Nazaj</button>
		</div>
    </div>

		
	<div class="left-border-for-children" style="width:'100%'">
		
		<div class="form-fieldset-header mt-1">
			<h2>Kontrola</h2>
		</div>
		
		<div class="display-row mt-1 display-row-form" >
            <span>Kontrolna številka</span>
             <kinput disabled type="text" v-model="pridelovalec.kontrolnaStevilka"/>
		</div>
		<div class="display-row mt-1 display-row-form" >
            <span>Shema certificiranja</span>
             <kinput disabled type="text" value="Integrirana pridelava"/>
		</div>
		<div class="display-row mt-1 display-row-form" >
            <span>Področje</span>
            <dropdownlist 
                    :data-items="podrocjacertificiranja.map(i=>i.naziv)"
                    v-model="kontrola.podrocjecertificiranja"
                    disabled
					
			></dropdownlist>
		</div>
		<div class="display-row mt-1 display-row-form" >
            <span>Status kontrole</span>
            <dropdownlist 
                    :data-items="statusnadzora.map(i=>i.naziv)"
                    v-model="kontrola.status"
                    disabled
					
			></dropdownlist>
		</div>
		<div class="display-row mt-1 display-row-form" >
            <span>Član skupine</span>
			<kinput disabled type="text" v-model="pridelovalec.skupina"/>
		</div>
		
		<div class="form-fieldset-header mt-1">
		
			<h2>NADALJNJI UKREPI ZA IZVAJALCA</h2>
               
        
		</div>

		<Grid   
                        :data-items="kontrola.ukrepizvajalca"
                        :columns='[
                             { field: "knttocka", title:"Kontr. tč.",editable:true,width: "80px"},
                             { field: "ukrep", title:"Nadaljnji ukrep",editable:true,width: "80px"},
                             { field: "rok", title:"Rok",editable:true,width: "150px", type:"date",editor:"date",format:"{0:d}"},
                             { field: "dolocil", title:"Določil",editable:true,width: "80px"},
							 
							 { field: "podaljsanrok", title:"Podaljšan rok",editable:true,width: "150px", type:"date",editor:"date",format:"{0:d}"},
							 { field: "klic", title:"Klic",editable:true, width: "150px" },
							 { field: "eposta", title:"E-Pošta",editable:true, width: "150px" },
							 { field: "status", title:"Status",editable:true, width: "150px" },
							 { field: "zakljucil", title:"Zaključil",editable:true, width: "150px" },
							 { field: "datum", title:"Datum",editable:true,width: "150px", type:"date",editor:"date",format:"{0:d}"},
               { cell: "uredi", filterable: false, width: "100px" },
							 { cell: "brisi", filterable: false, width: "100px" },
              

                        ]'
                        :filterable="false"
                        :sortable="false"
                        @itemchange="ukrepizvajalcachange"
                        :edit-field="'edit'"
		>
		<template v-slot:brisi="{props}">
            <kbutton theme-color="error" size="small"  @click="removeukrepizvajalca(props.dataItem)"
                    >
                    Briši
            </kbutton>
        </template>
        <template v-slot:uredi="{props}">
            <kbutton theme-color="primary" size="small"  @click="editukrepizvajalca(props.dataItem)"
                    >
                    Uredi
            </kbutton>
        </template>
    	<toolbar>
            <div class="km-widget km-buttongroup k-widget k-button-group">
			<kbutton title="Dodaj"
					theme-color="primary" size="small"
					@click="dodajukrepizvajalca"
					>
					Dodaj
			</kbutton>
			</div>
				
			</toolbar>
			<GridNoRecords >
						Ni podatkov!
			</GridNoRecords>
		</Grid>
		
		<div class="form-fieldset-header mt-1">
			<h2>Komunikacija z izvajalcem</h2>
        </div>

		<Grid  
                        :data-items="kontrola.komunikacija"
                        :columns='[
                             { field: "tip", title:"Ime",editable:true,width: "100px"},
							 { field: "datum", title:"Datum",editable:true,width: "150px", type:"date",editor:"date",format:"{0:d}"},
                             { field: "izvedel", title:"Izvedel",editable:true, width: "220px" },
                              { cell: "uredi", filterable: false, width: "100px" },
							 { cell: "brisi", filterable: false, width: "220px" }
                        ]'
                        :filterable="false"
                        :sortable="false"
                        @itemchange="komunikacijachange"
                        :edit-field="'edit'"
		>
		<template v-slot:brisi="{props}">
			<td>
            <kbutton theme-color="error" size="small"  @click="removekomunikacija(props.dataItem)"
                    >
                    Briši
            </kbutton>
		</td>
        </template>

		

    	<toolbar>
            <div class="km-widget km-buttongroup k-widget k-button-group">
			<kbutton title="Dodaj"
					theme-color="primary" size="small"
					@click="dodajkomunikacija"
					>
					Dodaj
			</kbutton>
			</div>
				
			</toolbar>
			<GridNoRecords >
						Ni podatkov!
			</GridNoRecords>
		</Grid>

		<div class="form-fieldset-header mt-1">
			<h2>Dopis</h2>
        </div>

		<Grid  
                        :data-items="kontrola.dopis"
                        :columns='[
                          	{ field: "datum", title:"Datum",editable:true,width: "150px", type:"date",editor:"date",format:"{0:d}"},
							{ field: "stdopisa", title:"Številka dopisa",editable:true,width: "100px"},
							{ field: "izvedel", field:"Izvedel", title:"Izvedel", editable:true, width: "220px" },
							{ cell: "brisi", width: "220px" }
                        ]'
                        :filterable="false"
                        :sortable="false"
                        @itemchange="dopischange"
                        :edit-field="'edit'"
		>
		<template v-slot:brisi="{props}">
			<td>
            <kbutton theme-color="error" size="small"  @click="removedopis(props.dataItem)"
                    >
                    Briši
            </kbutton>
		</td>
        </template>

    	<toolbar>
            <div class="km-widget km-buttongroup k-widget k-button-group">
			<kbutton title="Dodaj"
					theme-color="primary" size="small"
					@click="dodajdopis"
					>
					Dodaj
			</kbutton>
			</div>
				
			</toolbar>
			<GridNoRecords >
						Ni podatkov!
			</GridNoRecords>
		</Grid>
    <div class="form-fieldset-header mt-1">
			<h2>NADALJNJI UKREPI ZA NADZOR</h2>
        </div>
		<Grid  
                        :data-items="kontrola.ukrepnadzor"
                        
                        :columns='[
							{ field: "ukrepnadzor", title:"Nadaljni ukrep",editable:true,width: "300px"},
              { field: "datum", title:"Datum",editable:true,width: "150px", type:"date",editor:"date",format:"{0:d}"},
							
							{ field: "dolocil", title:"Določil", editable:true, width: "220px" },
              
              { field: "zakljucil", title:"Zaključil", editable:true, width: "220px" },
              { field: "datumzakljucka", title:"Datum zaključka",editable:true,width: "150px", type:"date",editor:"date",format:"{0:d}"},
              { cell: "uredi", filterable: false, width: "100px" },
							{ cell: "brisi", width: "100px" }
                        ]'
                        :filterable="false"
                        :sortable="false"
                        @itemchange="ukrepnadzorchange"
                        :edit-field="'edit'"
		>
		<template v-slot:brisi="{props}">
			
            <kbutton theme-color="error" size="small"  @click="removeukrepnadzor(props.dataItem)"
                    >
                    Briši
            </kbutton>
		
        </template>
        <template v-slot:uredi="{props}">
            <kbutton theme-color="primary" size="small"  @click="editukrepnadzor(props.dataItem)"
                    >
                    Uredi
            </kbutton>
        </template>

    	<toolbar>
            <div class="km-widget km-buttongroup k-widget k-button-group">
			<kbutton title="Dodaj"
					theme-color="primary" size="small"
					@click="dodajukrepnadzor"
					>
					Dodaj
			</kbutton>
			</div>
				
			</toolbar>
			<GridNoRecords >
						Ni podatkov!
			</GridNoRecords>
		</Grid>




	</div>
		
	
</form>
    </div>
    </div>
    </div>
    </div>

</template>

<style scoped>
	.mt-1 {
	margin-top: 1rem !important;
	}

	.display-row{
		display:flex;
		align-items:center;
		gap:1rem;
		
	}
	.display-row-form>*:first-child{
		flex:0 0 25%;
	}
</style>
<script>

import { mapState, mapActions,mapMutations } from 'vuex'
import { Dialog, DialogActionsBar } from '@progress/kendo-vue-dialogs';
//import '@progress/kendo-ui' // This will import the entire Kendo UI library
import '@progress/kendo-theme-default/dist/all.css'
import Vue from 'vue';
import { DatePicker, DateTimePicker } from '@progress/kendo-vue-dateinputs';
import { Input } from '@progress/kendo-vue-inputs';
import { provideIntlService } from '@progress/kendo-vue-intl';
import { Checkbox } from "@progress/kendo-vue-inputs";
import { Button, ButtonGroup } from '@progress/kendo-vue-buttons';
import { Grid, GridToolbar, GridNoRecords  } from '@progress/kendo-vue-grid';
import { MultiSelect,DropDownList,ComboBox } from '@progress/kendo-vue-dropdowns';
import StatusDownCell from './support/SifrantStatusovDropDown';
import StatusCommandCell from './support/SifrantStatusovCommandCell';
//import SifrantKontrolaDownCell from './support/SifrantKontrolaDropDown';
import PridelovalecKratko from './support/PridelovalecKratko';
import { authHeader } from '../helpers';
import { Upload } from '@progress/kendo-vue-upload';

import { process } from '@progress/kendo-data-query';
import moment from 'moment'
import { sifrant } from '../store/sifrant.module';
import { kontrolaService } from '../services/kontrola.service';





export default {
  components:{
	'kinput': Input,
	'kbutton': Button,
	'kendo-datepicker': DatePicker,
	'kendodatetimepicker': DateTimePicker,
    'multiselect': MultiSelect,
    'kendo-checkbox': Checkbox,
      'ukaznigumbiknt': StatusCommandCell,
      'ddcell': StatusDownCell,
      'combobox': ComboBox,
      'dropdownlist': DropDownList,
  //    'sifkontroleddcell': SifrantKontroleDownCell,
      'Grid': Grid,
      'GridNoRecords': GridNoRecords,
      'toolbar': GridToolbar,
      'pridelovalec':PridelovalecKratko,
	  upload: Upload,
  },
  props:['sezona','pridelovalecid','shema','kontrolaid'],
    data () {
        return {
			ipobsegcertificiranjafilter:{},
			ip:{},
            kontrola:{
				podrocjecertificiranja:"",
				status:"",
				stkontrole:0,
				datumnadzora:new Date(),
				vrstakontrole:"",
				lokacijakontrole:"",
				zacetekkontrole:new Date(),
				koneckontrole:new Date(),
				trajanje:0,
				vzorcenje:true,
				vzorci:[],
				prisotneosebe:[],
				seznam:[],
				storitvepodizvajalca:[],
				podizvajalci:[{naziv:"",naslov:"",dejavnost:"",datumzadnjeaktivnosti:new Date(),edit:true}],
				storitvepodizvajalca:[{naziv:"",dejavnost:"",datumzadnjeaktivnosti:new Date(),edit:true}],
				neskladnosti:"",
				posebnosti:"",
				zuppripombe:false,
				zuppripomba:"",
				zupposlannaemail:"", //email iz podatkov
				zupprevzetnasedezu:"",
				zupprevzetobkontroli:"",
				zakljuceno:"",
				izvajalcikontrole:[{naziv:"",datum:new Date(),edit:true}]
			},
			files:[],
			kontrolorji:[],
			sifrantTree:{},
            dataLoading:false,
			podrocjacertificiranja:[{naziv:"IPS",id:1},{naziv:"IPG",id:2},{naziv:"IPP",id:3},{naziv:"IPZ",id:4},{naziv:"IPH",id:5}],
           statusnadzora:[
			{id:1,naziv:"nova"},
			{id:2,naziv:"v teku"},
			{id:3,naziv:"odločitev"},
			{id:4,naziv:"konec"},
		   ],
		   statusprisotnihoseb:[
			{id:1,naziv:"izvajalec"},
			{id:2,naziv:"pooblaščenec"},
			{id:3,naziv:"ostali prisotni"},
			
		   ],
            dataSezona:this.sezona,
          
            updatedData: [],
            editID: null,
          
         
            sort: [
                //{ field: 'vrstakulture', dir: 'asc' } 
            ],
            columns: [

               { field: "zaporednastevilka", title:"ID nadzora",width: "100px",filterable:false,footerCell:this.nogaNazivVsot,type:"number",editable:false},
			   { field: "statusnadzora", title:"Status nazdora",width: "150px"},
			   { field: "shema", title:"shema"},
			   { field: "podrocje", title:"podrocje"},
			   { field: "izvajalec", title:"izvajalec"},
			   { field: "naslov", title:"naslov"},
			   { field: "datumkontrole", filterable:false, title:"Datum kontrole",width: "150px", type:"date",editor:"date",format:"{0:d}"},
               { field: "trajanje", title:"Trajanje (h)",width: "80px",filterable:false,type:"number",editor:"numeric",format:"{0:n2}"},
            
			   { field: "vrstakontrole", title:"Vrsta kontrole",width: "150px"},
			   { field: "kontrolor", cell:"kontrolor", title:"Kontrolor",width: "240px"},
               { field: "mnenjekontrolorja", title:"Mnenje",width: "90px"},
             
			   { field: "tveganje", title:"Ocena tveganja"},
			   { field: "cena", title:"cena"},
			   { field: "statusplacila", title:"Status plačila"},
			 
                //{ field: "vzorci", title:"Vzorci",width: "100px"},
                //{ field: "posebnosti", title:"Posebnosti",width: "100px"},
                //{ field: "priloge", title:"Priloge",width: "100px"},
                //{ field: "sifrakontrolorja", title:"Kontrolor",width: "100px"},
              /*   { field: "kolicina", title:"Količina",width: "100px",filterable:false,type: "number",footerCell: this.nogaVsotaKolicina,width: "150px",format: '{0:n2}'},
                { field: "merskaenotanaziv", title:"Enota",width: "100px",filterable:false},
                //{ field: "enota", title:"Enota", type:"string",filterable:false,width: "80px"},
                { field: "veljavnostcertifikataod", filterable:false, title:"Datum določitve statusa",width: "170px", cell:this.formatDate},
                //template: "#= kendo.toString(kendo.parseDate(veljavnostcertifikataod, 'yyyy-MM-dd'), 'MM/dd/yyyy') #"},
                //filter:'date',format: "{0:d}"},
               // { field: "veljavnostcertifikatado", title:"Veljavnost statusa", type:"string",editor: 'date',width: "150px",format: '{0:d}'},

                { field: "statuspridelkanaziv", title:"Status",width: "150px"},
                */
                { cell: 'ukaznigumbi', width: '210px', hidden:this.editDisabled },
            ],
          

           

        }
    },
      computed: {
		saveurl:{
            get(){
				return `${Vue.prototype.$config.apiUrl}/datoteke/dodaj`
			}
		},
		removeurl:{
            get(){
				return `${Vue.prototype.$config.apiUrl}/datoteke/brisi`
			}
		},
        editDisabled(){
          return (this.pridelovalec.pisanje==0)
        },

        ...mapState({gridData(state) {
          return state.kontrola.kontrola;
        }}),

        ...mapState('pridelava', ['pridelovalec']) ,
        ...mapState('sifrant', ['sifrant']) ,
        ...mapState('users',['sezonePisanje']),

        hasItemsInEdit() {
            return this.gridData.filter(p => p.inEdit).length > 0;
        },
        kontrolorjiSifrant(){
          return this.kontrolorji.map(i=>{
                i.naziv=i.priimek+' '+i.ime;
                return i;            
          })
        }
      
           },
    created () {

 if(!this.sezona)
        this.dataSezona={sezona:Math.max(...this.sezonePisanje.map(s=>s.sezona))};
      else
      this.dataSezona={sezona:this.sezona};
		
	  this.naloziPodatke();

      
    },
  


    methods: {
      ...mapActions('pridelava', ['loadIdPoSezoni','loadOne']),
        ...mapActions('kontrola', ['load','save','loadPreteklaSezona']),
        ...mapActions({naloziSifrant: 'sifrant/load'}),
        ...mapMutations('kontrola',['update',"add","remove","makeEditable",'replace']),
        rowRenderFunction: function (h, trElement , defaultSlots, props ) {
            console.log(trElement);
            console.log(props.dataItem);
            if(props.dataItem.jeaktivna!=1)
            trElement.data.class+=" deleted_element";

                return trElement;
            },
             nogaNazivVsot: function (h, emptyElement , props, listeners ) {
            return h('span', {}, ['Vsota:']);
        },
        //gvž in število
        nogaVsotaStevila: function (h, emptyElement , props, listeners ) {
          if(this.gridData)
            return h('span', {}, [kendo.toString(this.gridData.reduce((acc, current) => acc+=current.jeaktivna?(current.stevilo?current.stevilo:0):0, 0),"n0")]);
        },
        nogaVsotaGvz: function (h, emptyElement , props, listeners ) {
          if(this.gridData)
            return h('span', {}, [kendo.toString(this.gridData.reduce((acc, current) => acc+=current.jeaktivna?(current.vsotagvz?current.vsotagvz:0):0, 0),"n3")]);
        },
        formatDate: function (h, emptyElement , props, listeners ) {
            if(props.dataItem.inEdit)
              return emptyElement
            else
             return h('td', {attrs:{colspan:1}}, [kendo.toString(kendo.parseDate(props.dataItem[props.field]),'d')]);
        },
		izracunajtrajanje(){
			var diff =(this.kontrola.zacetekkontrole.getTime() - this.kontrola.koneckontrole.getTime()) / 1000;
  			diff /= (60 * 60);
  			Vue.set(this.kontrola,"trajanje",Math.abs(Math.ceil(diff)));
			
		},
		dodajkomunikacija(){
            if(!this?.kontrola?.komunikacija)
                this.kontrola.komunikacija=[];

            const newRecord = { 
				tip:"",
				datum:new Date(),
				izvedel:"",
				edit:true};

				this.kontrola.komunikacija.push(newRecord);
        }   ,
        removekomunikacija(e){
        
                var index=this.kontrola.komunikacija.indexOf(e);
                if(index>=0)
                        this.kontrola.komunikacija.splice(index,1)

        },
        komunikacijachange: function (e) {
            e.dataItem[e.field]=e.value;
		},
		dodajukrepizvajalca(){
            if(!this?.kontrola?.ukrepizvajalca)
                this.kontrola.ukrepizvajalca=[];

            const newRecord = { 
				knttocka:"",
				ukrep:"",
				rok:new Date(),
				dolocil:"",
				podaljsanrok:new Date(),
				klic:"",
				eposta:"",
				status:"",
				zakljucil:"",
				datum:new Date(),
				edit:true};

				this.kontrola.ukrepizvajalca.push(newRecord);
        }   ,
        editukrepizvajalca(e){
          var index=this.kontrola.ukrepizvajalca.indexOf(e);
                if(index>=0)
                      Vue.set(this.kontrola.ukrepizvajalca[index],'edit',true);
},
        removeukrepizvajalca(e){
        
                var index=this.kontrola.ukrepizvajalca.indexOf(e);
                if(index>=0)
                        this.kontrola.ukrepizvajalca.splice(index,1)

        },
        
        ukrepizvajalcachange: function (e) {
            e.dataItem[e.field]=e.value;
		},
		dodajdopis(){
            if(!this?.kontrola?.dopis)
                this.kontrola.dopis=[];

            const newRecord = { 
              stdopisa:"",
				naslov:"",
				izvedel:"",
				datum:new Date(),
				edit:true};

				this.kontrola.dopis.push(newRecord);
        }   ,
        removedopis(e){
        
                var index=this.kontrola.dopis.indexOf(e);
                if(index>=0)
                        this.kontrola.dopis.splice(index,1)

        },
        dopischange: function (e) {
            e.dataItem[e.field]=e.value;
		},

		dodajukrepnadzor(){
            if(!this?.kontrola?.ukrepnadzor)
                this.kontrola.ukrepnadzor=[];

            const newRecord = { 
              ukrepnadzor:"",
              datum:new Date(),
              dolocil:"",
              zakljucil:"",
				      edit:true};

				this.kontrola.ukrepnadzor.push(newRecord);
        }   ,
        removeukrepnadzor(e){
        
                var index=this.kontrola.ukrepnadzor.indexOf(e);
                if(index>=0)
                        this.kontrola.ukrepnadzor.splice(index,1)

        },
        ukrepnadzorchange: function (e) {
            e.dataItem[e.field]=e.value;
		},
    editukrepnadzor(e){
          var index=this.kontrola.ukrepnadzor.indexOf(e);
                if(index>=0)
                      Vue.set(this.kontrola.ukrepnadzor[index],'edit',true);
},
		
		
		authorize(event) {
			event.headers=authHeader();
		},
		onAdd(event) {
		
        this.files=event.newState;
      },
      onRemove(event) {
        this.files=event.newState;
      },
      onProgress(event) {
		console.log("progres");
		console.log(event);
		this.files=event.newState;
      },
      onStatusChange(event) {
		
		console.log("done");
		console.log(event)
		this.files=event.newState;
		Vue.set(this.kontrola,'seznam',{datotekaid:event.response?.response?._id,files:this.files});
      },

		saveData(e){
          //this.save( this.dataSezona);
        },
		handleSubmit(e){

		e.preventDefault();
		},
		onFilterChange(event,podshema) {
			console.log(podshema)
            
			Vue.set(this.ipobsegcertificiranjafilter,podshema,filterBy(this.ipobsegcertificiranja.filter(i=>i.področje==podshema).slice(), event.filter))
			console.log(this.ipobsegcertificiranjafilter[podshema])
        },
            //error handle za prazen šifrnat!!!!
        naloziPodatke: function(){
          this.dataLoading=true;
		 let sezona=this.dataSezona.sezona;
		 let shema="IP";
		 let pridelovalecid=this.pridelovalecid;
		 let thisComp=this;
		 var sifranti=[
		  this.naloziSifrant({sezona:sezona,sifrant:"kontrolorjiip"}).then(

		  	data=>{
				this.kontrolorji=this.sifrant["kontrolorjiip"];
			},
  			error=>{console.log("tukaj sem!!!");this.dataLoading=false;}
			
			),
			//mogoče filter po vrsti
		this.naloziSifrant({sezona:sezona,sifrant:"ipobsegcertificiranja"}).then(()=>{
            thisComp.ipobsegcertificiranja=thisComp.sifrant["ipobsegcertificiranja"];
			for (let podshema of thisComp.podrocjacertificiranja)
				Vue.set(thisComp.ipobsegcertificiranjafilter,podshema.naziv,thisComp.ipobsegcertificiranja.filter(i=>i.področje==podshema.naziv).slice())
				
        })];
		
		Promise.all(sifranti).then(()=>{
			console.log("Šifranti naloženi")
        

          
		this.loadOne({sezona:sezona,pridelovalecid:pridelovalecid}).then(p=>{

			console.log("Grem po stranko")

			let pridelava=this.pridelovalec.sheme.find(s=>s.sezona==sezona&&s.shema==shema);
		if(!pridelava){
			//javi napako, ne dodaj podatkov
			console.log("resne težave, če ni sheme")
			return;
		}
		//naloži kontrolo, če je id, če ni, napaka...
		this.pridelovalec.kontrolnaStevilka=pridelava.kontrolnaStevilka;
		let novaprijava={
		obseg:{},
		seznam:{datotekaid:null,files:[]},
		datumseznama:(new Date()).toISOString()};

		if(!pridelava.ip)
		{
			Vue.set(pridelava.ip,'prijava',novaprijava)
		}
		if(!pridelava.ip.prijava){
		Vue.set(pridelava.ip,'prijava',novaprijava)
		}
		Vue.set(thisComp,"ip",pridelava.ip)
		thisComp.files=thisComp.ip.prijava?.seznam?.files;
		if(!thisComp.ip.prijava.obseg||Array.isArray(thisComp.ip.prijava.obseg))
		Vue.set(thisComp.ip.prijava,'obseg',{});


		kontrolaService.loadOne(sezona,pridelovalecid,shema,this.kontrolaid).then(
			data=>{

				
				var datumi=["datumkontrole","datumnadzora","zacetekkontrole","koneckontrole"]
				//vzorci datum pregleda
				//datumzadnjeaktivnosti podizvajalci in stortivepodizvajalca
				//izvajalcikontrole datum

				//kontrolor v kontrolorji
				if(!data.kontrolorji)
					data.kontrolorji=[];
				if(!data.kontrolorji.includes(data.kontrolornaziv))
					data.kontrolorji.push(data.kontrolornaziv);

				for (let d of datumi){
					if(data[d])
						data[d]=provideIntlService(thisComp).parseDate( data[d]);
				}
        for (let ukrep of data.ukrepizvajalca){
            ukrep.rok=provideIntlService(thisComp).parseDate( ukrep.rok);
            ukrep.podaljsanrok=provideIntlService(thisComp).parseDate( ukrep.podaljsanrok);
            ukrep.datum=provideIntlService(thisComp).parseDate( ukrep.datum);
        }

        for (let ukrep of data.ukrepnadzor){
          ukrep.datum=provideIntlService(thisComp).parseDate( ukrep.datum);
          ukrep.datumzakljucka=provideIntlService(thisComp).parseDate( ukrep.datumzakljucka);
          
      }

				console.log(data);
				Vue.set(thisComp,'kontrola',data);

			},
			err=>{}
		);

		

	  

		});

	});
          
        
      
        },
        sifranKontrolaChange: function(e,dataItem) {

          
               if(!dataItem.oldValues)
              dataItem.oldValues={}


            if(!dataItem.oldValues["vrstakontroleid"])
              dataItem.oldValues["vrstakontroleid"] =dataItem["vrstakontroleid"];

            if(!dataItem.oldValues["vrstakontrole"])
              dataItem.oldValues["vrstakontrole"] =dataItem["vrstakontrole"];



            Vue.set( dataItem, 'vrstakontrole',e.value.naziv);
              Vue.set( dataItem, 'vrstakontroleid',e.value.id);
            
    
        },
        sifrantNacinChange: function(e,dataItem) {

          
               if(!dataItem.oldValues)
              dataItem.oldValues={}


           
            if(!dataItem.oldValues["nacinkontrole"])
              dataItem.oldValues["nacinkontrole"] =dataItem["nacinkontrole"];



      
              Vue.set( dataItem, 'nacinkontrole',e.value.naziv);
            
    
        },
          sifranMnenjeChange: function(e,dataItem) {

          
               if(!dataItem.oldValues)
              dataItem.oldValues={}


            
            if(!dataItem.oldValues["mnenjekontrolorja"])
              dataItem.oldValues["mnenjekontrolorja"] =dataItem["mnenjekontrolorja"];

            Vue.set( dataItem, 'mnenjekontrolorja',e.value.naziv);
            
            
    
        },
        sifranMestoChange: function(e,dataItem) {

          
if(!dataItem.oldValues)
dataItem.oldValues={}



if(!dataItem.oldValues["mestokontrole"])
dataItem.oldValues["mestokontrole"] =dataItem["mestokontrole"];

Vue.set( dataItem, 'mestokontrole',e.value.naziv);



},

        kontrolorChange: function(e,dataItem) {

          
               if(!dataItem.oldValues)
              dataItem.oldValues={}


            if(!dataItem.oldValues["kontrolorid"])
              dataItem.oldValues["kontrolor"] =dataItem["kontrolor"];

         
            Vue.set( dataItem, 'kontrolor',e.value.id);
            this.test=e.value.id
         
    
        },
        itemChange: function (e) {
            if(!e.dataItem.oldValues)
              e.dataItem.oldValues={}
            if(!e.dataItem.oldValues[e.field])
              e.dataItem.oldValues[e.field] =e.dataItem[e.field];
          
          Vue.set( e.dataItem, e.field,e.value);

        //  if(e.field=="stevilo")
          //    Vue.set( e.dataItem, 'vsotagvz',(e.value?e.value:0)*this.sifrant['proizvod'].find(s=>s.id==e.dataItem.proizvodid).gvz);              
           
        },
        dodajIzPrejsnjeSezone(){
            this.loadPreteklaSezona({sezona:this.dataSezona.sezona,pridelovalecid:this.pridelovalecid,makeEditable:!this.editDisabled});

        },

        //default vrednosti
         vstavi() {
            const dataItem = { inEdit: true,jeaktivna:1,
                  zaporednastevilka:this.gridData.reduce((a,c)=>{return c.zaporednastevilka>a?c.zaporednastevilka:a},0)+1,
                  datumkontrole:new Date(),
                  vrstakontroleid:this.sifrant["vrstakontrolepridelovalca"][0].id,
                  vrstakontrole:this.sifrant["vrstakontrolepridelovalca"][0].naziv,
                  nacinkontrole:this.sifrant["nacinkontrolepridelovalca"][0].naziv,
                  mestokontrole:this.sifrant["mestokontrolepridelovalca"][0].naziv,
                  //mestokontrole:"",
                  mnenjekontrolorjaid:this.sifrant["mnenjekontrolorja"][0].id,
                  mnenjekontrolorja:this.sifrant["mnenjekontrolorja"][0].naziv
                   };
            this.add(dataItem);
        },
        edit: function (e) {
            e.dataItem.inEdit = true;
            e.dataItem.jeaktivna = 1;
            
            this.update(e.dataItem);
        },
        cancel(e) {
            if (e.dataItem.id>0) {
            var dataItem=e.dataItem;
            for (const value in dataItem.oldValues){
               Vue.set( dataItem, value,dataItem.oldValues[value]);
            }
             Vue.set( dataItem, jeaktivna,0);
             Vue.set( dataItem, jeaktivna,1);
              this.update(dataItem);
            
            } else {
                this.remove(e.dataItem);
            }
        },
        saveItem: function(e) {
           e.dataItem.inEdit = undefined;
             e.dataItem.jeaktivna = 1;
            this.update(e.dataItem);
        },
        removeItem(e) {
            e.dataItem.inEdit =!e.dataItem.inEdit;
            e.dataItem.jeaktivna=e.dataItem.jeaktivna?0:1;
            this.update(e.dataItem);

        },
        //tu je treba dodat še shemo...
       sezonaChange(event) {
            const sezona = event.value;
            this.dataSezona=sezona;
            //this.loadOne({sezona:this.dataSezona.sezona,pridelovalecid:this.pridelovalecid}).then(pridelovalec=>{
              //this.pridelovalecid=pridelovalec.id;
              this.$router.push({ name: 'kontrolaukrepip', params: {sezona:sezona.sezona,pridelovalecid:this.pridelovalec._id,kontrolaid:this.kontrolaid,podshema:this.kontrola.podrocjecertificiranja}} );
             this.pridelovalec.sezona=this.sezona;
             this.naloziPodatke();
             // });



        },
/*
             @datastatechange="dataStateChange"
dataStateChange (event) {
            console.log("DataStateChange");
            console.log(event);
            this.createAppState(event.data);
            this.dataResult = process(this.gerk, {});

        },
  */    
        async shraniKontrole () {
			//kaj narediš s seznamom in obsegom.... vprašaj...

			await kontrolaService.saveOne(this.kontrola,this.sezona,this.pridelovalecid,this.shema,this.kontrolaid)
              //this.save();
    },
       
        
    }
};
</script>

